// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as StateSerialization$LiteracyplanetTupperware from "../StateSerialization.res.mjs";
import * as V2ExerciseStateStoreContext$LiteracyplanetTupperware from "./V2ExerciseStateStoreContext.res.mjs";

function usePersistedState(persistedState, dispatch) {
  var match = React.useState(function () {
        return false;
      });
  var setReady = match[1];
  var hydrateExerciseStore = function (stringifiedState) {
    dispatch({
          TAG: "SetStore",
          _0: StateSerialization$LiteracyplanetTupperware.parseAndDecodeWithDefault(stringifiedState)
        });
    return function (param) {
      dispatch("ResetStore");
    };
  };
  React.useEffect((function () {
          var unsubscribe = Belt_Option.map(persistedState, hydrateExerciseStore);
          setReady(function (param) {
                return true;
              });
          return unsubscribe;
        }), []);
  return match[0];
}

function useModeAndPersistedState(assessment, persistedState) {
  var match = V2ExerciseStateStoreContext$LiteracyplanetTupperware.useDispatch();
  var dispatch = match[1];
  var ready = usePersistedState(persistedState, dispatch);
  React.useEffect((function () {
          if (Belt_Option.isNone(persistedState)) {
            dispatch({
                  TAG: "SetMode",
                  _0: assessment ? "Assessment" : "Activity"
                });
          }
          
        }), [assessment]);
  return ready;
}

export {
  usePersistedState ,
  useModeAndPersistedState ,
}
/* react Not a pure module */
